function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "6. Cabriolet car");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "_6._Cabriolet_car",
  "data-name": "6. Cabriolet car"
}, /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M36.71,29.29a1,1,0,0,0-1.42,1.42A1,1,0,0,0,36.71,29.29Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M12.38,29.08a1,1,0,0,0-1.09,1.63C12.47,31.83,13.85,29.65,12.38,29.08Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M25,23H23a1,1,0,0,0,0,2h2A1,1,0,0,0,25,23Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M43.82,20.46l-8.38-1.4c-3.44-2.95-4.95-4.57-8.19-5.53a1,1,0,0,0-.56,1.92c2.55.76,3.79,2,5.61,3.55H22V17a1,1,0,0,0-2,0v2H13V18a1,1,0,0,0-2,0v1H2a1,1,0,0,0-.53,1.83C-.16,24.11,0,23.52,0,27a4,4,0,0,0,4,4H7.1a5,5,0,0,0,9.8,0H31.1a5,5,0,0,0,9.8,0H44a4,4,0,0,0,4-4V25.39A5,5,0,0,0,43.82,20.46ZM12,33a3,3,0,1,1,3-3A3,3,0,0,1,12,33Zm24,0a3,3,0,1,1,3-3A3,3,0,0,1,36,33Zm8-4H40.9a5,5,0,0,0-9.8,0H16.9a5,5,0,0,0-9.8,0H4a2,2,0,0,1-2-2c0-1.88-.1-2.54.31-3.37C3.42,21.41,3.46,21,4.24,21c36.12,0,28.32-.39,39.25,1.43A3,3,0,0,1,46,25H45a1,1,0,0,0,0,2h1A2,2,0,0,1,44,29Z"
}));

var SvgCabrioletCar = function SvgCabrioletCar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCabrioletCar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CabrioletCar.cd1e339e.svg";
export { ForwardRef as ReactComponent };